import type { TooltipPosition } from './types';

export const OPPOSITE_DIRECTION_MAP = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
} as const;

export const getTailStyles = (position: TooltipPosition) => {
  const isLeftOrRight = ['left', 'right'].includes(position);
  const positionCapitalized = position.charAt(0).toUpperCase() + position.slice(1);
  const oppositeDirection = OPPOSITE_DIRECTION_MAP[position];

  return {
    // Tail
    '&::before': {
      content: '""',
      position: 'absolute',
      width: 0,
      height: 0,
      filter: `drop-shadow(${POSITION_SHADOW_DIRECTION_MAP[position]} 1px rgba(0, 0, 0, 0.15));`,
      ...(isLeftOrRight
        ? {
            transform: `translateX(${position === 'right' ? '-' : ''}100%) translateY(50%)`,
            bottom: '50%',
            borderTop: 'var(--tooltip-tail-size) solid transparent',
            borderBottom: 'var(--tooltip-tail-size) solid transparent',
          }
        : {
            transform: `translateX(50%) translateY(${position === 'bottom' ? '-' : ''}100%)`,
            right: '50%',
            borderLeft: 'var(--tooltip-tail-size) solid transparent',
            borderRight: 'var(--tooltip-tail-size) solid transparent',
          }),
      [`border${positionCapitalized}`]: `var(--tooltip-tail-size) solid`,
      zIndex: 2,
      [oppositeDirection]: 0,
      [`border${positionCapitalized}Color`]: 'white',
    },
    // Bridge (space between trigger and tooltip, required not to lose hover state when pointer is in the gap)
    '&::after': {
      content: '""',
      position: 'absolute',
      zIndex: 1,
      [position]: '100%',
      ...(isLeftOrRight
        ? {
            bottom: '50%',
            transform: 'translateY(50%)',
            width: HORIZONTAL_OFFSET,
            height: '100%',
          }
        : {
            right: '50%',
            transform: 'translateX(50%)',
            height: VERTICAL_OFFSET,
            width: '100%',
          }),
    },
  };
};

const POSITION_SHADOW_DIRECTION_MAP = {
  top: '0px 2px',
  bottom: '0px -2px',
  left: '2px 0px',
  right: '-2px 0px',
};

export const HORIZONTAL_OFFSET = 12;
export const VERTICAL_OFFSET = 13;
